import type { CSSProperties } from 'react';
import { CatalogImage } from '@entities/shop-catalog';

import classes from './life-icon.module.css';

type Props = { empty?: boolean; size?: number; className?: string };

export const LifeIcon = ({ empty = false, size = 24, className }: Props) => (
  <CatalogImage
    kind={empty ? 'life-empty' : 'life'}
    fallback={empty ? '/life-empty-v2.webp' : '/life-v2.webp'}
    className={`${classes.icon} ${className ?? ''}`}
    style={{ '--life-icon-size': `${size / 16}rem` } as CSSProperties}
    alt=""
    aria-hidden="true"
  />
);
